import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";

const CTASection = ({ sectionRef }) => {
  const { t } = useTranslation();

  return (
    <section
      data-testid="cta-section"
      className="py-20 md:py-32 bg-gradient-to-br from-[#E07A5F] to-[#D0694E] relative overflow-hidden"
      ref={sectionRef}
    >
      <div className="absolute inset-0 opacity-10">
        <div
          className="w-full h-full"
          style={{
            backgroundImage:
              "url(\"data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E\")",
          }}
        ></div>
      </div>
      <div className="max-w-4xl mx-auto px-6 text-center relative z-10">
        <h2 className="reveal text-4xl md:text-5xl font-bold text-white mb-6 font-['Playfair_Display']">
          {t("home.cta.title")}
        </h2>
        <p className="reveal stagger-1 text-xl text-white/90 mb-10 max-w-2xl mx-auto">
          {t("home.cta.subtitle")}
        </p>
        <div className="reveal stagger-2 flex flex-col sm:flex-row gap-4 justify-center">
          <Link to="/booking">
            <Button
              data-testid="cta-book-btn"
              className="bg-white text-[#E07A5F] hover:bg-[#F4F1DE] text-lg px-10 py-6 rounded-full font-medium btn-hover-pulse"
            >
              {t("home.cta.planBtn")}
            </Button>
          </Link>
          <Link to="/contact">
            <Button
              data-testid="cta-contact-btn"
              variant="outline"
              className="border-2 border-white text-white hover:bg-white/10 text-lg px-10 py-6 rounded-full transition-all duration-300 hover:scale-[1.03]"
            >
              {t("home.cta.contactBtn")}
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
